export const FOLLOW_UP_HTN_BOT_START_REQUESTED =
  'FOLLOW_UP_HTN_BOT_START_REQUESTED'
export const FOLLOW_UP_DM_BOT_START_REQUESTED =
  'FOLLOW_UP_DM_BOT_START_REQUESTED'
export const FOLLOW_UP_DM_START_FROM_DEEP_LINK =
  'FOLLOW_UP_DM_START_FROM_DEEP_LINK'
export const OPEN_DM_FOLLOW_UP_BOT_SCREEN = 'OPEN_DM_FOLLOW_UP_BOT_SCREEN'
export const DM_FOLLOW_UP_BOT_LINK_OPENED = 'dm_follow_up_bot_link_opened'
export const FOLLOW_UP_HTN_START_FROM_DEEP_LINK =
  'FOLLOW_UP_HTN_START_FROM_DEEP_LINK'
export const OPEN_HTN_FOLLOW_UP_BOT_SCREEN = 'OPEN_HTN_FOLLOW_UP_BOT_SCREEN'
export const HTN_FOLLOW_UP_BOT_LINK_OPENED = 'htn_follow_up_bot_link_opened'

export const FOLLOW_UP_MH_BOT_START_REQUESTED =
  'FOLLOW_UP_MH_BOT_START_REQUESTED'
export const TRIGGER_NEXT_MH_FOLLOW_UP_BOT_REQUESTED =
  'TRIGGER_NEXT_MH_FOLLOW_UP_BOT_REQUESTED'
export const TRIGGER_NEXT_MH_FOLLOW_UP_BOT_RECEIVED =
  'TRIGGER_NEXT_MH_FOLLOW_UP_BOT_RECEIVED'
export const OPEN_MH_FOLLOW_UP_BOT_SCREEN = 'OPEN_MH_FOLLOW_UP_BOT_SCREEN'
export const FOLLOW_UP_MH_START_FROM_DEEP_LINK =
  'FOLLOW_UP_MH_START_FROM_DEEP_LINK'
export const FUB_INVITATION_ID_ADDED = 'FUB_INVITATION_ID_ADDED'
export const FUB_INVITATION_LINK_OPENED_REQUESTED =
  'FUB_INVITATION_LINK_OPENED_REQUESTED'
export const FUB_INVITATION_LINK_OPENED_RECEIVED =
  'FUB_INVITATION_LINK_OPENED_RECEIVED'
export const FOLLOW_UP_PRIMARY_HMO_BOT_START_REQUESTED =
  'FOLLOW_UP_PRIMARY_HMO_BOT_START_REQUESTED'
export const OPEN_PRIMARY_HMO_FOLLOW_UP_BOT_SCREEN =
  'OPEN_PRIMARY_HMO_FOLLOW_UP_BOT_SCREEN'
